import React from 'react';
import PropTypes from 'prop-types';
import head from 'lodash.head';
import { getScoreLabel } from '../../../../../../utils/shared/trcUtils';
import WrittenComprehensionStatusHeader from './WrittenComprehensionStatusHeader';
import SelectionList from '../../SelectionList';
import SectionHeader from '../../SectionHeader';
import { generateReactKey } from '../../../../../../utils/shared/commonUtils';

const WrittenComprehensionTable = ({ resultGroup, isIgnored, scoreList }) => {
    if (!resultGroup) return null;
    const { results, complete } = resultGroup;
    const hasMultipleResults = results.length > 1;
    if (!complete) {
        return <h4>Written Comprehension has not been administered</h4>;
    }
    const { score, maxScore } = head(results);
    return (
        <section className="section-block">
            <SectionHeader titles={['Written Comprehension', getScoreLabel(score, maxScore)]} />
            {results.map((result, index) => {
                return (
                    <div className="section-table" key={generateReactKey(index, score)}>
                        {hasMultipleResults && (
                            <WrittenComprehensionStatusHeader result={result} index={index} />
                        )}
                        <SelectionList list={scoreList} resultScore={result.score} />
                    </div>
                );
            })}
            {isIgnored && (
                <h4 className="font-weight-normal">
                    <>
                        <b>Note:</b> Written Comprehension scores do not count towards the
                        student&apos;s overall book performance or affect the assessment flow.
                    </>
                </h4>
            )}
        </section>
    );
};

WrittenComprehensionTable.defaultProps = {
    resultGroup: null,
    isIgnored: false,
    scoreList: [],
};

WrittenComprehensionTable.propTypes = {
    resultGroup: PropTypes.object,
    isIgnored: PropTypes.bool,
    scoreList: PropTypes.array,
};

export default WrittenComprehensionTable;
